import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { merge } from "rxjs";
import { tap } from "rxjs/operators";
import { SharedService } from "src/app/services/sharedService";
import { TasDataSource } from "src/app/services/tasGovTable.datasource";
import { TaxPayerService } from "src/app/services/taxPayer.service";
import { UserService } from "src/app/services/user.service";
import { VehicleDialogComponent } from "../dialogs/vehicle-dialog/vehicle-dialog.component";

@Component({
  selector: "app-vehicle",
  templateUrl: "./vehicle.component.html",
  styleUrls: ["./vehicle.component.css"],
})
export class VehicleComponent implements OnInit, OnDestroy, OnChanges {
  @Input()
  currentYear: any;
  @Input()
  category: any;
  @Input()
  type;
  @Input() actions = true;
  currentNIU: any;
  currentYearInt: any;
  currentUser: any;
  displayedYears = [];
  dataSource: TasDataSource;
  refreshDataSubscription: any;
  displayedColumns: string[] = [
    'tin',
    'companyName',
    'municipalityName',
    'licensePlate',
    'chassisNumber',
    'municipalRegistry',
    'vehicleMake',
    'vehicleModel',
    'action'
  ];

  @Input() company: any;
  filterObject: any = {};
  loading = { inProgress: false };

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  constructor(
    public translate: TranslateService,
    public taxPayerService: TaxPayerService,
    private sharedService: SharedService,
    public userService: UserService,
    private router: Router,
    public dialog: MatDialog
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.category) {
      this.displayedColumns = [
        'tin',
        'companyName',
        'municipalityName',
        'licensePlate',
        'chassisNumber',
        'municipalRegistry',
        'vehicleMake',
        'vehicleModel',
        'action'
      ];
    }
  }

  async ngOnInit() {
    this.currentUser = await this.userService.getCurrentUser().toPromise();

    this.dataSource = new TasDataSource(this.taxPayerService);

    this.refreshDataSubscription = this.sharedService.cashPaymentPrintEmitter?.subscribe(val => {
      this.dataSource = new TasDataSource(this.taxPayerService);
      this.loadTable();
    });
  }

  ngAfterViewInit() { }

  stringifyWithUTC(obj) {
    return JSON.stringify(obj, (key, value) => {
      if (obj && obj[key] instanceof Date) {
        const utcDateString = new Date(obj[key].getTime() - (obj[key].getTimezoneOffset() * 60000)).toISOString();
        return utcDateString;
      }
      return value;
    });
  }

  ngOnDestroy(): void {
    this.refreshDataSubscription && this.refreshDataSubscription.unsubscribe();
  }

  loadTable() {
    this.loading.inProgress = true;

    this.dataSource.loadData(
      'vehicle',
      this.stringifyWithUTC(this.filterObject),
      'asc',
      'tin',
      this.paginator.pageIndex,
      this.paginator.pageSize,
      this.filterObject,
      this.loading
    );
  }

  advancedSearch(filter) {
    this.filterObject = { ...filter };

    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        tap(() => this.loadTable())
      )
      .subscribe();

    this.loadTable();
  }

  resetAdvancedSearch() {
    this.filterObject = {};
    this.paginator.pageIndex = 0;
    this.dataSource.emptyData();
  }

  goToTaxPayer(row) {
    this.router.navigate(['tx_declarations'], { 
      queryParams: { tin: row.tin ? row.tin : row.username } 
    });
  }

  canAddVehicle() {
    if (this.currentUser) {
      return ['ADMIN'].includes(this.currentUser.role)
    }

    return false
  }

  openVehicleDialog(vehicle: any): void {
    const dialogRef = this.dialog.open(VehicleDialogComponent, {
      width: '800px',
      panelClass: 'custom-dialog-container',
      data: vehicle
    });
  
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.reload) {
        this.paginator.pageIndex = 0;
        this.loadTable();
      }
    });
  }
  
}
